export default __webpack_public_path__ + "static/media/bg5.e0c726ec.png";